angular.module("vgresiduos").controller("EquipmentEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidade/equipamento/${$stateParams.id}`);
		};
	}
]);
